import { ReactElement } from 'react';
import Procard from '../components/Procard';
import PlanGate from '../components/PlanGate';

/**
 * To Show All the Insight of the devices.
 * @returns - A InsightPage Component.
 */
export default function InsightPage(): ReactElement {
  return (
    <PlanGate requiredPlan="Professional">
    <div className="flex flex-col gap-4 flex-1 py-4">
      <div className="flex flex-1 bg-container-500 p-4 max-h-[30%] flex-col rounded">
        <div className="text-sm font-medium text-gray-500">Ventilation Status</div>
        <div className="flex flex-1 justify-center items-center">
          <Procard />
        </div>
      </div>
      <div className="flex flex-1 gap-4">
        <div className="flex flex-1 bg-container-500 p-4 flex-col rounded">
          <div className="text-sm font-medium text-gray-500">Energy Optimisation</div>
          <div className="flex flex-1 justify-center items-center">
            <Procard />
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <div className="flex flex-1 bg-container-500 p-4 flex-col rounded">
            <div className="text-sm font-medium text-gray-500">Particle Source Detection</div>
            <div className="flex flex-1 justify-center items-center">
              <Procard />
            </div>
          </div>
          <div className="flex flex-1 bg-container-500 p-4 flex-col rounded">
            <div className="text-sm font-medium text-gray-500">Filter Change Detection</div>
            <div className="flex flex-1 justify-center items-center">
              <Procard />
            </div>
          </div>
        </div>
      </div>
    </div>
    </PlanGate>
  );
}
